import { graphql } from 'react-relay';

export const followSellerMutation = graphql`
    mutation followSellerMutation($input: FavoriteSellerInput!, $userId: String!) {
        favoriteSeller(input: $input) {
            seller {
                favoritesByUser(userIds: $userId) {
                    serviceId
                }
            }
        }
    }
`;
